/**
 * Toast - Modal style notification
 */
import { useEffect } from 'react';
import './Toast.css';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastProps {
  message: string | null;
  type?: ToastType;
  onClose: () => void;
  autoClose?: number; // milliseconds, 0 = no auto close
  title?: string;
}

const defaultTitles: Record<ToastType, string> = {
  success: 'Gelukt',
  error: 'Fout',
  warning: 'Waarschuwing',
  info: 'Info',
};

const Toast = ({ message, type = 'info', onClose, autoClose, title }: ToastProps) => {
  // Error messages wachten op OK klik, andere types sluiten automatisch na 3 seconden
  const effectiveAutoClose = autoClose !== undefined ? autoClose : (type === 'error' ? 0 : 3000);

  useEffect(() => {
    if (message && effectiveAutoClose > 0) {
      const timer = setTimeout(onClose, effectiveAutoClose);
      return () => clearTimeout(timer);
    }
  }, [message, effectiveAutoClose, onClose]);

  if (!message) return null;

  const displayTitle = title || defaultTitles[type];

  return (
    <div className="toast-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={`toast-popup ${type}`}>
        <div className="toast-header">
          <h3>{displayTitle}</h3>
        </div>
        <div className="toast-body">
          <p className="toast-message">{message}</p>
        </div>
        <div className="toast-footer">
          <button className="toast-close-btn" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
};

export default Toast;
